window.TizianoSearch = window.TizianoSearch || (() => {
  const cache = new Map();
  const normalize = value => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
  const words = value => String(value || '').replace(/(\d+(?:[.,]\d+)?)\s+(cm|mm|ml|kg)\b/gi, '$1$2').match(/\d+(?:[.,]\d+)?(?:cm|mm|ml|kg)\b|[\p{L}\p{N}]+/gu) || [];
  const phonetic = value => normalize(value).replace(/ph/g, 'f').replace(/([a-z])\1+/g, '$1');
  const stem = value => {
    const word = normalize(value);
    const colour = word.match(/^(rot|grun|blau|gelb|weiss|schwarz|braun|gold|silber)(?:e|en|er|es|em)?$/);
    if (colour) return colour[1];
    if (word.length > 5 && /(?:en|er)$/.test(word)) return word.slice(0, -2);
    if (word.length > 4 && /(?:e|n|s)$/.test(word)) return word.slice(0, -1);
    return word;
  };
  const near = (a, b) => {
    if (a === b) return true;
    if (Math.abs(a.length - b.length) > 1 || Math.min(a.length,b.length) < 5) return false;
    let i = 0;
    while (i < Math.min(a.length,b.length) && a[i] === b[i]) i++;
    if (a.length === b.length) return a.slice(i+1) === b.slice(i+1) || (a[i] === b[i+1] && a[i+1] === b[i] && a.slice(i+2) === b.slice(i+2));
    return a.length > b.length ? a.slice(i+1) === b.slice(i) : a.slice(i) === b.slice(i+1);
  };
  const matches = (word, term, fuzzy) => {
    const a = stem(word), b = stem(term);
    return a === b || (b.length >= 4 && a.includes(b)) || (fuzzy && near(a,b));
  };
  const quote = value => '"' + String(value).replace(/["\\]/g, ' ').replace(/\s+/g, ' ').trim() + '"';
  function compile(term, products) {
    const clean = String(term).replace(/["\\]/g,' ').replace(/\s+/g,' ').trim().slice(0,120);
    const tokens = words(clean).filter(t=>!['mit','und','fur','in','aus','der','die','das','von','im','zum','ein','eine'].includes(normalize(t))).slice(0,8);
    if (!tokens.length) return clean;
    const seasonal = tokens.some(t=>/^(weihnacht|advent|ostern|oster|fruhling|sommer|herbst|winter)/.test(normalize(t)));
    const primary = products.flatMap(p=>[
      ...words(p.title).map(w=>['title',w]),
      ...words(p.type).map(w=>['product_type',w]),
      ...(p.variants || []).flatMap(v=>[
        ...words(v.title).filter(w=>!words(p.title).some(titleWord=>matches(titleWord,w,false))).map(w=>[v.sku ? 'variants.sku' : 'title',w,v.sku || p.title]),
        ['variants.sku',v.sku],
        [v.sku ? 'variants.sku' : 'title',v.barcode,v.sku || p.title]
      ])
    ]).filter(([,word])=>word);
    const tags = products.flatMap(p=>(p.tags||[]).flatMap(tag=>words(tag).map(w=>['tag',w])));
    const clauses = tokens.map(token=>{
      const related = {wichtel:['zwerg'],teelichthalt:['teelicht'],kerzenhalt:['kerzenständer','kerzenleuchter']}[stem(token)] || [];
      let found = primary.filter(([,word])=>matches(word,token,false) || related.some(alias=>matches(word,alias,false)));
      const titleWords = primary.filter(([field])=>field === 'title').map(([,word])=>word);
      const partialTitle = titleWords.some(word=>normalize(word).startsWith(normalize(token)) && normalize(word) !== normalize(token))
        && !titleWords.some(word=>stem(word) === stem(token));
      // A partial product name must not expand into unrelated seasonal tags.
      if ((seasonal && !partialTitle) || stem(token) === 'lichtkugel' || !found.length) found.push(...tags.filter(([,word])=>matches(word,token,false)));
      const size = normalize(token).match(/^(\d+(?:[.,]\d+)?)cm$/);
      if (size) {
        products.filter(p=>(p.options || []).some(option=>/^(hohe|breite|lange|durchmesser|grosse)(?:\s*\(?(?:in\s+)?cm\)?)?$/.test(normalize(option)))).forEach(p=>{
          (p.variants || []).forEach(v=>{
            if (/^\d+(?:[.,]\d+)?$/.test(v.title) && Number(v.title.replace(',','.')) === Number(size[1].replace(',','.'))) found.push([v.sku ? 'variants.sku' : 'title',v.sku || p.title]);
          });
        });
      }
      if (!found.length) found = primary.filter(([,word])=>matches(word,token,true));
      if (!found.length && normalize(token).length >= 5) found = primary.filter(([field,word])=>field === 'title' && phonetic(word) === phonetic(token));
      const unique = [...new Set(found.map(([field,word,value])=>field+':'+quote(value || word)))].slice(0,60);
      return '('+(unique.length ? unique.join(' OR ') : 'title:'+quote(token))+')';
    });
    const query = '(title:'+quote(clean)+' OR ('+clauses.join(' AND ')+'))';
    return query.length <= 6500 ? query : clean;
  }
  async function candidates(term) {
    const url = new URL(theme.routes.search_url, location.origin);
    url.searchParams.set('q',term);
    url.searchParams.set('type','product');
    url.searchParams.set('options[unavailable_products]','show');
    url.searchParams.set('section_id','tz-search-candidates');
    const read = async page => {
      const pageUrl = new URL(url);
      pageUrl.searchParams.set('page',page);
      const response = await fetch(pageUrl,{signal:AbortSignal.timeout(6000)});
      if (!response.ok) throw new Error('Search candidates unavailable');
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const data = doc.querySelector('[data-search-candidates]');
      if (!data) throw new Error('Search candidates missing');
      return JSON.parse(data.textContent);
    };
    const first = await read(1);
    if (first.pages > 4) return null;
    const rest = await Promise.all(Array.from({length:Math.max(0,first.pages-1)},(_,i)=>read(i+2)));
    return {products:first.products.concat(...rest.map(page=>page.products)), collection:first.collection};
  }
  function resolve(term) {
    if (!term || term.startsWith('(title:"') || /\b(?:title|tag|body|variants\.sku):/i.test(term)) return Promise.resolve(term);
    // Keep broad seasonal discovery on Shopify's native relevance ranking.
    if (/^(weihnachten|weihnachtsdeko|ostern|osterdeko|sommer|sommerdeko|herbst|herbstdeko|winter|winterdeko|fruhling|fruhlingsdeko)$/.test(normalize(term.trim()))) return Promise.resolve(term);
    if (!cache.has(term)) {
      if (cache.size >= 30) cache.delete(cache.keys().next().value);
      cache.set(term,candidates(term).then(data=>{
        if (!data) return term;
        if (data.collection?.products?.length) {
          const clauses = data.collection.products.map(p=>{
            const title = 'title:'+quote(p.title);
            const sku = (p.variants || []).map(v=>v.sku).filter(Boolean).sort((a,b)=>a.length-b.length)[0];
            const skuQuery = sku ? 'variants.sku:'+quote(sku) : '';
            return skuQuery && skuQuery.length < title.length ? skuQuery : title;
          });
          const query = '(title:'+quote(term)+' OR ('+clauses.join(' OR ')+'))';
          if (query.length <= 6000) return query;
        }
        return compile(term,data.products);
      }).catch(()=>{cache.delete(term);return term;}));
    }
    return cache.get(term);
  }
  const displayTerm = term => String(term || '').startsWith('(title:"') ? String(term).split('"')[1] : String(term || '');
  const publicURL = value => {
    const url = new URL(value,location.origin);
    if (url.pathname !== theme.routes.search_url) return url;
    url.searchParams.set('q',displayTerm(url.searchParams.get('q')));
    ['section_id','type','options[prefix]','options[unavailable_products]','options'].forEach(key=>url.searchParams.delete(key));
    return url;
  };
  const requestURL = async value => {
    const url = new URL(value,location.origin);
    if (url.pathname !== theme.routes.search_url) return url.toString();
    url.searchParams.set('q',await resolve(displayTerm(url.searchParams.get('q'))));
    url.searchParams.set('type','product');
    url.searchParams.set('options[unavailable_products]','last');
    return url.toString();
  };
  const cleanLinks = (root=document) => {
    root.querySelectorAll('a[href]').forEach(link=>{
      const url = new URL(link.href,location.origin);
      if (url.origin === location.origin && url.pathname === theme.routes.search_url && url.searchParams.has('q')) link.href = publicURL(url).toString();
    });
  };
  return {resolve,compile,normalize,displayTerm,publicURL,requestURL,cleanLinks};
})();

async function tizianoSearchNavigate(value, form) {
  if (form?.hasAttribute('data-search-submitting')) return;
  form?.setAttribute('data-search-submitting', '');
  form?.setAttribute('aria-busy', 'true');
  form?.setAttribute('loading', '');
  try {
    const target = await TizianoSearch.requestURL(value);
    try {
      sessionStorage.setItem('tz-search-navigation-v1', JSON.stringify({url:target, at:Date.now()}));
    } catch (_) {}
    location.assign(target);
  } finally {
    form?.removeAttribute('data-search-submitting');
    form?.removeAttribute('aria-busy');
    form?.removeAttribute('loading');
  }
}

if (!window.__tzSearchSubmitBound) {
  window.__tzSearchSubmitBound = true;
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.getAttribute('role') !== 'search') return;
    const term = form.querySelector('input[name="q"]')?.value.trim();
    if (!term) return;
    event.preventDefault();
    const url = new URL(form.action,location.origin);
    url.searchParams.set('q',TizianoSearch.displayTerm(term));
    tizianoSearchNavigate(url, form);
  },true);
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('form[role="search"] a[href]');
    if (!link || link.target || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || url.pathname !== theme.routes.search_url || !url.searchParams.get('q')) return;
    event.preventDefault();
    tizianoSearchNavigate(url, link.closest('form'));
  });
  document.addEventListener('collection:reloaded',()=>TizianoSearch.cleanLinks());
}

if (document.querySelector('[data-tz-search-page]') && document.documentElement.dataset.tzSearchResolved !== 'true' && !window.__tzSearchPageLoading) {
  window.__tzSearchPageLoading = true;
  const page = document.querySelector('[data-tz-search-page]');
  const section = page.closest('.shopify-section');
  const current = TizianoSearch.publicURL(location.href);
  history.replaceState(history.state,'',current);
  page.setAttribute('aria-busy','true');
  TizianoSearch.requestURL(current).then(async target=>{
    const url = new URL(target);
    url.searchParams.set('section_id',section.id.replace('shopify-section-',''));
    const fetchSection = async () => {
      const response = await fetch(url,{signal:AbortSignal.timeout(10000)});
      if (!response.ok) throw new Error('Search unavailable');
      const html = new DOMParser().parseFromString(await response.text(),'text/html');
      const result = html.getElementById(section.id);
      if (!result?.querySelector('[data-tz-search-page]')) throw new Error('Search response missing');
      return result;
    };
    let updated = await fetchSection();
    // Saved links can point beyond the last page after the result set changes.
    // Retry page one once, preserving the search term, filters and sorting.
    if (Number(url.searchParams.get('page')) > 1 && !updated.querySelector('#ProductGridContainer .product-card')) {
      url.searchParams.delete('page');
      updated = await fetchSection();
      current.searchParams.delete('page');
      history.replaceState(history.state,'',current);
    }
    updated.querySelectorAll('motion-list').forEach(list=>list.setAttribute('motion-reduced',''));
    const nextPage = updated.querySelector('[data-tz-search-page]');
    [...page.children].filter(child=>!child.classList.contains('title-wrapper')).forEach(child=>child.remove());
    page.append(...[...nextPage.children].filter(child=>!child.classList.contains('title-wrapper')));
    TizianoSearch.cleanLinks(section);
    document.dispatchEvent(new CustomEvent('collection:reloaded'));
  }).catch(()=>{
    const retry = new URL(current);
    retry.searchParams.set('options[unavailable_products]','last');
    retry.searchParams.set('type','product');
    if (document.documentElement.dataset.tzSearchFallback !== 'true') location.replace(retry);
  }).finally(()=>{
    document.documentElement.classList.remove('tz-search-loading');
    document.querySelector('[data-tz-search-page]')?.removeAttribute('aria-busy');
    window.__tzSearchPageLoading = false;
  });
}

if (document.querySelector('[data-tz-search-page]') && document.documentElement.dataset.tzSearchResolved === 'true') {
  TizianoSearch.cleanLinks();
}

if (!customElements.get('search-drawer')) {
  customElements.define(
    'search-drawer',
    class SearchDrawer extends DrawerElement {
      constructor() {
        super();
      }

      get shouldAppendToBody() {
        return false;
      }

      get input() {
        return this.querySelector('input[type="search"]');
      }

      get focusElement() {
        return this.querySelector('input[type="search"]');
      }
    }
  );
}

if (!customElements.get('search-typed')) {
  customElements.define(
    'search-typed',
    class SearchTyped extends HTMLElement {
      constructor() {
        super();

        Motion.inView(this, this.init.bind(this));
      }

      get startDelay() {
        return this.hasAttribute('data-delay') ? parseFloat(this.getAttribute('data-delay')) : 0;
      }

      async init() {
        this.insertCursor();
        await this.start(this.getAttribute('data-first-text'), this.startDelay);

        setTimeout(async () => {
          await this.reset();
          await this.start(this.getAttribute('data-last-text'), 0);
        }, 600);
      }

      async start(text, delay) {
        this.innerHTML = text;
        await Motion.animate(this, { width: [0, `${this.scrollWidth}px`] }, { duration: 1, delay }).finished;
        this.cursor.classList.add('blink');
      }

      async reset() {
        this.cursor.classList.remove('blink');
        await Motion.animate(this, { width: 0 }, { duration: 0.25 }).finished;
      }

      insertCursor() {
        if (this.cursor) return;

        this.cursor = document.createElement('span');
        this.cursor.className = 'typed-cursor';
        this.cursor.setAttribute('aria-hidden', true);
        this.cursor.innerHTML = '|';
        this.parentElement.insertBefore(this.cursor, this.nextSibling);
      }
    }
  );
}

if (!customElements.get('predictive-search')) {
  customElements.define(
    'predictive-search',
    class PredictiveSearch extends HTMLFormElement {
      constructor() {
        super();

        this.cachedMap = new Map();
        this.focusElement = this.input;

        this.resetButton.addEventListener('click', this.clear.bind(this));
        this.input.addEventListener('click', this.hideTypewriter.bind(this));
        this.input.addEventListener('input', theme.utils.debounce(this.onChange.bind(this), 300));
        this.input.addEventListener('focus', this.onFocus.bind(this));
      }

      get input() {
        return this.querySelector('input[type="search"]');
      }

      get resetButton() {
        return this.querySelector('button[type="reset"]');
      }

      get typewriter() {
        return this.input.previousElementSibling;
      }

      hideTypewriter() {
        if (this.typewriter && !this.typewriter.hasAttribute('hidden')) {
          this.typewriter.setAttribute('hidden', '');
        }
      }

      onFocus(event) {
        if (this.closest('.collection')) {
          document.body.classList.add('predictive-search-open');

          const searchTerm = this.getQuery();
          if (searchTerm.length === 0) return;

          const url = this.buildUrl().toString();
          this.renderSection(url, event);
        }
      }

      clear(event = null) {
        if (event) event.preventDefault();

        this.requestId = (this.requestId || 0) + 1;
        this.abortController?.abort();
        this.removeAttribute('loading');
        this.input.value = '';
        this.input.focus();
        this.removeAttribute('results');
      }

      getQuery() {
        return this.input.value.trim();
      }

      buildUrl() {
  const url = new URL(`${theme.routes.shop_url}${theme.routes.predictive_search_url}`);

  url.searchParams.set('q', this.getQuery());
  url.searchParams.set('resources[limit]', this.hasAttribute('data-limit') ? parseInt(this.getAttribute('data-limit')) : 3);
  url.searchParams.set('resources[limit_scope]', 'each');
  url.searchParams.set('resources[type]', 'product,collection,query');
  url.searchParams.set('resources[options][prefix]', 'last');
  url.searchParams.set('section_id', theme.utils.sectionId(this));
  return url;
}

      onChange() {
        if (this.getQuery().length === 0) {
          this.clear();
          return;
        }

        this.hideTypewriter();

        const url = this.buildUrl().toString();
        this.renderSection(url);
      }

      async renderSection(url) {
        const requestId = this.requestId = (this.requestId || 0) + 1;
        const term = this.getQuery();
        this.abortController?.abort();
        this.setAttribute('loading', '');
        try {
          const query = await TizianoSearch.resolve(term);
          if (requestId !== this.requestId || term !== this.getQuery()) return;
          const target = new URL(url);
          target.searchParams.set('q', query);
          target.searchParams.set('resources[options][unavailable_products]', 'last');
          const key = target.toString();
          let responseText = this.cachedMap.get(key);
          if (!responseText) {
            this.abortController = new AbortController();
            const response = await fetch(key, {signal:this.abortController.signal});
            if (!response.ok) throw new Error('Search unavailable');
            responseText = await response.text();
            this.cachedMap.set(key,responseText);
          }
          if (requestId !== this.requestId || term !== this.getQuery()) return;
          this.renderSearchResults(responseText);
          this.setAttribute('results', '');
        } catch (error) {
          if (error.name !== 'AbortError') this.removeAttribute('results');
        } finally {
          if (requestId === this.requestId) this.removeAttribute('loading');
        }
      }

      renderSearchResults(responseText) {
        const id = 'PredictiveSearchResults-' + theme.utils.sectionId(this);
        if (document.getElementById(id) === null) return;

        document.getElementById(id).innerHTML = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .getElementById(id).innerHTML;
        TizianoSearch.cleanLinks(document.getElementById(id));
      }
    }, { extends: 'form' }
  );
}

if (!customElements.get('predictive-search-overlay')) {
  customElements.define(
    'predictive-search-overlay',
    class PredictiveSearchOverlay extends OverlayElement {
      constructor() {
        super();

        this.addEventListener('click', this.onClick);
      }

      onClick() {
        setTimeout(() => {
          document.body.classList.remove('predictive-search-open');
        });
      }
    }
  );
}



